export default __webpack_public_path__ + "static/media/try-connect.aad2a9b0.svg";